import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  background-color: #fff4c1;
  border-radius: 8px;
`;

export const Content = styled.div`
  width: 90%;
  margin: 0 auto;
  padding: 12px 0px;
`;

export const ContentChildren = styled.div`
  margin-top: 12px;
`;

export const Label = styled.div`
  border-bottom: 1px solid #707070;
  color: #707070;
  width: 100%;
  padding-bottom: 6px;
`;
